// FullStory - commented out: import { FullStoryTrackEndLoadEvent } from '../services/full-story-set-user.service';

export const responseInterceptor = (response: any) => {
  try {
    if (
      response.config &&
      response.config.metadata &&
      response.config.metadata.startTime
    ) {
      // FullStory - commented out
      // FullStoryTrackEndLoadEvent(
      //   response.config.metadata.startTime,
      //   response.config.url,
      //   response.config.params,
      // );
    }
  } catch (e) {
    // TODO: Handle error
  }

  return response;
};
